export default __webpack_public_path__ + "static/media/certikBg.59113d63.png";